import React from 'react';
import PropTypes from 'prop-types';

import { SearchBox } from 'components/search/SearchBox';
import withSearchHandler from 'decorators/withSearchHandler';

import { PSPMarkdownContent } from 'components/psp/PSPMarkdown/';
import './PSPVehicleSearch.scss';

// Wrapper that provides default props and applies withSearchHandler
const enhance = (Component) => {
	const EnhancedComponent = withSearchHandler((props) => (
		<Component
			{...props}
			searchType="vehicle"
			additionalSearchParams={{ vehicle: 'car' }}
		/>
	));
	EnhancedComponent.displayName = 'EnhancedPSPVehicleSearch';
	return EnhancedComponent;
};
export function PSPVehicleSearch({ title, handleSearch, buttonText="Find Storage" }) {

	return (
		<div className="psp-vehicle-search">
			<div className="psp-vehicle-search-content">
				<PSPMarkdownContent
					content={title}
					additionalParams={{ heading: { size: 'medium' } }}
				/>
				<div className="psp-vehicle-search-right">
					<SearchBox
						id="psp-vehicle-search-box"
						inputLabel="Enter address, city or zip"
						handleSearch={handleSearch}
						hideOnScroll
						pinkButton
						buttonText={buttonText}
					/>
				</div>
			</div>
		</div>
	);
}

PSPVehicleSearch.propTypes = {
	title: PropTypes.string.isRequired,
	handleSearch: PropTypes.func,
	buttonText: PropTypes.string
};

export default enhance(PSPVehicleSearch);